export default "__VITE_ASSET__CA6jGHU5__"